import React from 'react'

const Error = () => {
  return (
    <div className='flex justify-center items-center text-white text-3xl h-screen ' >
        Error - 404 Not Found
    </div>
  )
}

export default Error;